<div class="row page-header">
    <div class="col-12">
        <h1>Metric Manager <small>View and optionally delete metrics</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary ml-2"
                            (click)="calculateMetrics()"
                            [disabled]="isCalculating"
                            title="Calculate goal metrics"
                        >
                            <i class="fas fa-calculator"></i> Calculate Metrics
                        </button>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Metric Manager'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                        [itemFormatter]="goalsGridItemFormatter"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Archived?'" [binding]="'isArchived'" [width]="75"> </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Calculated?'" [binding]="'isCalculated'" [width]="75"> </wj-flex-grid-column>

                        <wj-flex-grid-column [header]="'Who'" [binding]="'userId'" [dataMap]="allUserMap" [width]="75" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Metric'" [binding]="'name'" [width]="300" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Meetings'"
                            [binding]="'meetingNames'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="' '"
                            [binding]="'goalDirection'"
                            [dataMap]="goalDirectionMap"
                            [width]="70"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Goal'"
                            [binding]="'goal1'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Average'"
                            [binding]="'average'"
                            [width]="100"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sum'"
                            [binding]="'sum'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        @for (month of weekCols; track month) {
                            <wj-flex-grid-column
                                [binding]="'weekValues.' + month"
                                [align]="'center'"
                                [header]="month"
                                [width]="100"
                                [isRequired]="false"
                            >
                            </wj-flex-grid-column>
                        }
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
